export default "__VITE_ASSET__5934a39d__"